module.exports = __webpack_public_path__ + "img/zzlogo.3d5efdf0.png";